<div class="background1">

    <div class="modal-header">
        <h4 class="modal-title">Vsi dogodki</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        </button>
    </div>
    <div class="modal-body">
        <ul *ngIf="events.length > 0">
            <li *ngFor="let event of visibleEvents">
                <b>{{ event.startStr }}</b> - 
                <i>{{ event.title }}</i>
            </li>
        </ul>
        <div *ngIf="showMore" class="more-events">
            <span (click)="handleShowMore()" class="click">...Preglej vse</span>
        </div>
        <div *ngIf="events.length === 0">
            <p>Ni dogodkov.</p>
        </div>
    </div>
</div>
    